import {useContext, useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import {Navigate, Outlet} from 'react-router-dom';

import {SnackBarContext} from '../../contexts/SnackBarContext/SnackBarContext';
import {UserContext} from '../../contexts/UserContext/UserContext';
import {AppConfig} from '../../lib/AppConfig';

export const LoginGuard = () => {
  const [isInitializing, setIsInitializing] = useState(true);
  const {currentUser, isLoading, userContextLogout, isRoleCompany} = useContext(UserContext);
  const {dispatchMessage} = useContext(SnackBarContext);
  const {t} = useTranslation();

  useEffect(() => {
    if (isLoading) return;

    if (localStorage.getItem(AppConfig.LOCAL_STORAGE_SESSION_EXPIRED_KEY)) {
      dispatchMessage(t('shared.tokenExpiration.tokenExpired'), 'info');
      // always remove user from context, if session has expired.
      userContextLogout();
      localStorage.removeItem(AppConfig.LOCAL_STORAGE_SESSION_EXPIRED_KEY);
    }

    setIsInitializing(false);
  }, [dispatchMessage, t, userContextLogout, isLoading]);

  if (isInitializing || isLoading) {
    return null;
  }

  if (currentUser && isRoleCompany) {
    return <Navigate to={AppConfig.COMPANY_ADMIN_RECRUITING_MATCHES_PATH} />;
  }

  if (currentUser) {
    return <Navigate to={AppConfig.APPLICANT_DASHBOARD_PATH} />;
  }

  return <Outlet />;
};
